import https from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const BASE_URL = 'automationapps/v1';
const fetchFlows = (flowIds, sourceApp, portalId = PortalIdParser.get()) => https.get(`${BASE_URL}/summaries`, {
  query: {
    portalId,
    platformSourceApps: sourceApp,
    flowIds
  }
});
export default fetchFlows;